module.exports = __webpack_public_path__ + "static/media/079_thumb.4895ca35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/commission/images/079_thumb.jpg
// module id = 178
// module chunks = 0